import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import {
    deletedRestoreSubjectCheck,
    deletedSubjectCheck,
    setSubjectCheck,
    setSubjectCheckRestoreData,
    updateSubjectCheck,
} from "./subjectCheckTypeSlice";
import { ISubjectCheckCreate, ISubjectCheckPayload } from "../types";
import { IErrorResponse, IRootState } from "../../../../types";

const GetSubjectTypes = createAsyncThunk("get/subject/check", async (_, { dispatch, rejectWithValue, getState }) => {
    try {
        const response = await request.get("/subject-check-types");
        const lang = getState() as IRootState;
        const defaultLanguage = lang.languages.defaultLanguage;
        dispatch(setSubjectCheck({ data: response.data, defaultLanguage }));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetSubjectCheck = createAsyncThunk(
    "set/subject/check",
    async (data: ISubjectCheckCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/subject-check-types", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteSubjectCheck = createAsyncThunk(
    "delete/subject/check",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/subject-check-types/${id}`);

            dispatch(deletedSubjectCheck(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditSubjectCheck = createAsyncThunk(
    "edit/subject/check",
    async (data: ISubjectCheckPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/subject-check-types/${data.id}`, data);
            dispatch(updateSubjectCheck(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteSubjectCheck = createAsyncThunk("get/delete/subject/check", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/subject-check-types/deleted-items`);

        dispatch(setSubjectCheckRestoreData(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteSubjectCheck = createAsyncThunk(
    "restore/delete/subject/check",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/subject-check-types/restore/${id}`);

            dispatch(deletedRestoreSubjectCheck(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetSubjectTypes,
    SetSubjectCheck,
    DeleteSubjectCheck,
    EditSubjectCheck,
    GetDeleteSubjectCheck,
    RestoreDeleteSubjectCheck,
};
